import { render, staticRenderFns } from "./StampForm.vue?vue&type=template&id=161905b0&"
import script from "./StampForm.vue?vue&type=script&lang=js&"
export * from "./StampForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('161905b0')) {
      api.createRecord('161905b0', component.options)
    } else {
      api.reload('161905b0', component.options)
    }
    module.hot.accept("./StampForm.vue?vue&type=template&id=161905b0&", function () {
      api.rerender('161905b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/StampForm.vue"
export default component.exports